import createClient from 'openapi-fetch';

import { getBaseUrl } from '@/lib/env';

import { createAcceptLanguageMiddleware } from './accept-language-middleware';
import { createAuthMiddleware } from './auth-middleware';
import type { paths } from './schema';

const apiClient = createClient<paths>({
  baseUrl: getBaseUrl(),
  credentials: 'include',
});

apiClient.use(createAcceptLanguageMiddleware());

const authMiddleware = createAuthMiddleware();
apiClient.use(authMiddleware);

export { apiClient };
